export default __webpack_public_path__ + "static/media/Major Rune Stone of the Eternal Blaze (V).36c4d00a.jpg";